import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/authentication.service';
import { ReportsService } from '../../services/reports.service';
import * as moment from 'moment/moment';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public reportData: Object = {
    dailyUsers: 0,
    monthlyUsers: 0,
    yearlyUsers: 0,
    dailyTasks: 0,
    monthlyTasks: 0,
    yearlyTasks: 0,
  };
  public updateDate: any;

  constructor(private AuthenticationService: AuthenticationService, private ReportsService: ReportsService) { }

  ngOnInit() {
    this.getAdminReports();
  }

  getAdminReports() {
    this.ReportsService.getAdminReport().subscribe(
      (data: any) => { 
        this.reportData = data;
        this.updateDate = moment();
      },
      err => console.error(err)
    );
  }

}


// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/reports/admin/admin.component.ts